import { Validator } from '@vista-digital/validator';
import { ButtonColor } from '../../../button/types/color';
import { ButtonIconPosition } from '../../../button/types/icon-position';
import { ButtonSize } from '../../../button/types/size';
import { formButtonConfigValidator } from './button-config';
export const defaultFormCancelButtonConfig = {
    show: true,
    size: ButtonSize.Small,
    color: ButtonColor.Secondary,
    iconPosition: ButtonIconPosition.Left
};
export const defaultFormSubmitButtonConfig = {
    show: true,
    size: ButtonSize.Small,
    color: ButtonColor.Primary,
    iconPosition: ButtonIconPosition.Right
};
export const defaultFormConfig = {
    cancelButton: defaultFormCancelButtonConfig,
    submitButton: defaultFormSubmitButtonConfig
};
export const formConfigValidatorSchema = {
    cancelButton: formButtonConfigValidator,
    submitButton: formButtonConfigValidator
};
export const formConfigValidator = Validator.object(formConfigValidatorSchema);
//# sourceMappingURL=config.js.map